import { render } from "./projects.vue?vue&type=template&id=39fb5847&scoped=true"
import script from "./projects.vue?vue&type=script&lang=js"
export * from "./projects.vue?vue&type=script&lang=js"

import "./projects.vue?vue&type=style&index=0&id=39fb5847&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39fb5847"]])

export default __exports__